import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import {Mixins, Prop} from 'vue-property-decorator';
import {
  MEETINGS_VARIABLES,
  MENU_TO_REQUEST,
  NAV_IDS,
} from '@/core/values/core.values';
import {_MEETINGS_STORE, MEETING_EVENTS, MEETING_TYPES_NAMES} from '@/meetings/values/meetings.values';
import {MeetingPath} from '@/core/models/meeting-path.model';
import {Dictionary} from 'vue-router/types/router';
import {TOAST_TYPES} from '@/plugins/ed-toast/values/ed-toast.values';
import WebSocketMessageResponse from '@/content/models/web-socket-message-response.model';
import { PRESENTATION_MODE_EVENTS, EVENT_TYPES, SOCKET_EVENTS }  from '@/content/values/ed-presentation-mode.values';
import { _APP_STORE, CLASS_MESSAGES_TYPE, EMIT_JOIN_SOCKET_EVENT, GRADE_LEVEL_MESSAGES_TYPE, LOAD_CLASS_MESSAGES, LOAD_GRADE_LEVEL_MESSAGES, LOAD_ROOM_CLASS_MESSAGES, LOAD_TEMPLATE_MESSAGES, ROOM_CLASS_MESSAGES_TYPE, STUDENT_SOCKET_ROOM_EVENTS, TEMPLATE_MESSAGES_TYPE } from '@/core/values/app.values';
import { AUTH_STORE } from '@/auth/store/auth.store';
import NavRedirectMixin from '@/core/mixins/nav-redirect.mixin';
import {SCREEN_MIRRORING_EVENTS} from '@/values/screen.mirroring.values';
import {CALLS_EVENTS} from '@/components/calls/values/calls.values';
import {INav} from '../interfaces/nav.interface';
import {Status} from '@/models/status.model';
import {MY_CONTENT_ROUTES} from '@/app/private/my-content/my-content.router';
import {PRIVATE_ROUTES} from '@/app/private/private.routes';
import {User} from '../models/user.model';
import {HOMEWORK_SOCKET_MESSAGES_TYPES, HOMEWORKS_EVENTS} from '@/homework/values/homeworks.values';
import {HOMEWORKS_STORE} from '@/homework/store/homeworks.store';
import {MEETINGS_STORE} from '@/meetings/store/meetings.store';
import { AuthProvider } from '@/auth/providers/auth.provider';
import { _CLASSES_STORE } from '@/classes/values/classes.values';
import { MY_CONTENT_EVENTS } from '@/content/values/events';

@Component({})
export default class NavMixin extends Mixins(NavRedirectMixin) {

  @Prop() readonly modeIn: boolean;

  public status: Status = new Status();

  public mainSelected: any[] = [];
  public menuFormated: INav[] = [];
  public navMenuID: string = NAV_IDS.NAV;
  public meetingsMenu: MeetingPath = new MeetingPath(MEETINGS_VARIABLES.CLASSES_TAB);
  public classesMenu: any[] = [];
  public loadingObject:any = { id:-4, loading:false};
  public internalRoute = '';
  private eventProcessors = {
    Subscribe: this.processSubscribe,
    Leave: this.processLeave
  };
  private socketConnection : string = null;
  public menuId = 0;
  /* Computed */
  get isPublisher(): boolean {
    return this.$Auth.Store.isPublisher;
  }

  get isStudent(): boolean {
    return this.$Auth.Store.isStudent;
  }

  get isPresentationModeMeetings() : boolean {
    return this.presentationModeMeetings.length > 0;
  }

  get presentationModeMeetings() : number [] {
    return this.$store.state.MeetingsStore.presentationModeMeetings;
  }


  get currentCalls() : number [] {
    return this.$store.state.MeetingsStore.currentCalls;
  }

  get userInfo(): User {
    return this.$store.state.AuthStore.user;
  }

  get routeName(): string {
    let routeName = '';
    if(this.$route) {
      routeName = this.$route.name;
    }
    return routeName;
  }

  get menu(): INav[] {
    return this.menuFormated.map(m => {
      let isAlerted = false;
      if(m.verifyPresentationMode) {
        isAlerted = this.getVerifyPresentationMode(m);
      }
      return {
        ...m,
        isAlerted,
        active: this.routeName.includes(m.pathName)
      }
    });
  }

  get classes() {
    return {
      container: this.modeIn ? 'ed-nav--in-session' : 'ed-nav--out-session',
      submenu:  this.modeIn ? 'ed-header-in-session-menu-item' : 'ed-header-out-session-menu-item'
    }
  }

  get eduacClasses() {
    return this.$store.state.ClassesStore.classes;
  }

  get eduacClassRooms() {
    return this.$store.state.MeetingsStore.roomClasses;
  }

  getVerifyPresentationMode(menu: INav) {
    if(menu.hasToRequest === MENU_TO_REQUEST.CLASSES_CLASSES) {
      return !this.isPublisher && this.isPresentationModeMeetings;
    } else {
      return false;
    }
  }

  getMenu(menu: INav[]): INav[] {
    return menu.filter(
      m => !m.hideForRoles || AuthProvider.isUserAllowed(m.hideForRoles)
    ).map(m => {
      if (m.pathName === this.routeName) {
        m.active = true;
      }

      if (!m.noTranslate) {
        m.label = this.$i18n.t(`menu.${m.name}`).toString();
      }

      if (m.submenu) {
        m.submenu = this.getMenu(m.submenu);
      }
      
      return m;
    });
  }

  async goToRoute(item: INav) {
    if (!item.disabled) {
      if (item.hasToRequest) {
        const menu = JSON.parse(JSON.stringify(this.mainSelected));

        if (item.notHasToRequestForRoles?.length > 0) {
          if (!AuthProvider.isUserAllowed(item.notHasToRequestForRoles)) {
            this.menuFormated = menu;
            
            return;
          }
        }

        this.status.setLoading();
        const i = this.menu.indexOf(item);
        const submenu = await this.getSubMenuItems(item.hasToRequest);
        menu[i].submenu = menu[i].submenu ? menu[i].submenu.concat(submenu) : submenu;
        this.menuFormated = menu;
        this.status.setLoad();
      } else if(item.callback) {
        item.callback();
      } else {
        if(!item.submenu) {
          this.goTo(item.pathName, item.params);
        }
      }
    }
  }

  async goToRouteMobile(item: INav) {
    const menu = JSON.parse(JSON.stringify(this.mainSelected));
    if(!item.disabled) {
      if(item.hasToRequest === MENU_TO_REQUEST.CLASSES_CLASSES_AND_MY_CONTENT) {
        
        if (item.notHasToRequestForRoles?.length > 0) {
          if (!AuthProvider.isUserAllowed(item.notHasToRequestForRoles)) {
            this.menuFormated = menu;
            
            return;
          }
        }
        
        this.status.setLoading();
        const mycontent = await this.getMyContentMenu();
        const classes = await this.getClassesSubMenu();
        menu[0].submenu[1].submenu = classes;
        menu[0].submenu[2].submenu = menu[0].submenu[2].submenu.concat(mycontent);
        this.menuFormated = menu;
        this.status.setLoad();
      } else if(item.callback) {
        item.callback();
      } else if(!item.submenu) {
        this.goTo(item.pathName, item.params);
      }
    }
  }

  async getSubMenuItems(request: string) {
    let submenu = [];
    switch(request) {
      case MENU_TO_REQUEST.MY_CONTENT_CLASSES:
        submenu = await this.getMyContentMenu();
      break;
      case MENU_TO_REQUEST.CLASSES_CLASSES:
        submenu = await this.getClassesSubMenu();
      break;
    }
    return submenu;
  }

  reloadMenu(status) {
    if(status.inProcess){
      this.status.setLoading();
    } else{
      this.status.setLoad();
      this.menuId++;
    } 
  }

  async getMyContentMenu() {
    let classes;
    if(this.eduacClasses && this.eduacClasses.length > 0) {
      classes = this.eduacClasses;
    } else {
      classes = await this.$store.dispatch(_CLASSES_STORE.ACTIONS.GET_ALL_CLASSES_A);
    }
    const submenu = classes.map(cl => {
      return {
        name: cl.name,
        label: cl.name,
        pathName: MY_CONTENT_ROUTES.CLASSES.NAME,
        params: { id: cl.id }
      };
    });
    submenu.sort((a, b) => {
      if(a.label.toLowerCase() > b.label.toLowerCase()) {
        return 1;
      } else {
        return -1;
      }
    });
    return submenu;
  }

  async getClassesSubMenu() {
    const submenu = [];
    let classes;
    if(this.eduacClassRooms && this.eduacClassRooms.length > 0) {
      classes = this.eduacClassRooms;
    } else {
      classes = await this.$store.dispatch(_MEETINGS_STORE.ACTIONS.GET_ALL_ROOM_CLASSES_A);
    }
    await this.$store.dispatch(MEETINGS_STORE.ACTIONS.FETCH_LIVE_MEETINGS);

    const classesList = [];
    classes.forEach(cl => {
      if(!classesList.find(c => c.classId === cl.classId)) {
        classesList.push({
          classId: cl.classId,
          className: cl.className,
          meetings: {}
        });
      }
    });

    classes.forEach(cl => {
      classesList.forEach(menu => {
        if(menu.classId !== cl.classId) {
          return;
        } else {
          menu.meetings[cl.meetingId] = cl;
        }
      });
    });

    classesList.forEach(menu => {
      let isAlerted = false;
      const classFormat = {
        name: menu.className,
        label: menu.className,
        isAlerted,
        submenu: []
      };
      const meetingsKeys = Object.keys(menu.meetings);
      if(meetingsKeys.length > 1) {
        meetingsKeys.forEach(k => {
          const meeting = menu.meetings[k];
          const submenuList = this.getClassesOptions(meeting);
          classFormat.isAlerted = submenuList[0].isAlerted || classFormat.isAlerted;
          classFormat.submenu.push({
            name: meeting.name,
            label: meeting.name,
            submenu: submenuList
          });
        });
      } else {
        classFormat.submenu = this.getClassesOptions(menu.meetings[meetingsKeys[0]]);
        classFormat.isAlerted = classFormat.submenu[0].isAlerted;
      }
      if(this.isPublisher) {
        classFormat.submenu.push(this.getCustomizeOption(menu));
      }
      submenu.push(classFormat);
    });

    submenu.sort((a, b) => {
      if(a.label.toLowerCase() > b.label.toLowerCase()) {
        return 1;
      } else {
        return -1;
      }
    });

    return submenu;

  }

  getClassesOptions(meeting): INav[] {
    const presentLabel = this.isPublisher ? MEETING_TYPES_NAMES.PRESENT : 'join';
    return [
      {
        name: 'present',
        label: this.$i18n.t(`menu.${presentLabel}`).toString(),
        pathName: PRIVATE_ROUTES.JOIN_MEETING.NAME,
        params: {
          id: '-7',
          classId: meeting.classId.toString(),
          meetingId: meeting.meetingId
        },
        isAlerted: !this.isPublisher && this.presentationModeMeetings.includes(meeting.meetingId),
        disabled: !this.isPublisher && !this.presentationModeMeetings.includes(meeting.meetingId)
      },
      {
        name: 'call',
        label: this.$i18n.t('menu.call').toString(),
        pathName: null,
        callback: () => {
          this.checkIfMeetingFinishAndContinue(
            true,
              () => {
                this.makeCall({
                  params: { classId: meeting.classId.toString(), className: meeting.className },
                  meetingId: meeting.meetingId
                });
              }
          );
        },
        isAlerted:  this.currentCalls.includes(meeting.meetingId),
        disabled: !(Object.keys(this.$store.state.CallsStore.callConf).length == 0)
      }
    ];

  }

  public getCustomizeOption(meeting) {
    return {
      name: 'customize',
      label: this.$i18n.t('menu.customize').toString(),
      pathName: PRIVATE_ROUTES.CUSTOMIZE_MEETINGS.NAME,
      params: {
        meeting: '-1',
        id : meeting.classId.toString()
      }
    };
  }

  public popupBlockedToast(){
    this.$EdToast.create({
      msg: `${this.$i18n.t('menu.popupBlocked')}`,
      type: TOAST_TYPES.WARNING,
      timeout: 10000,
      top: '3em'
    });
  }

  /**
   * Init Call from the class popup
   * @param params
   * @param meetingId
   */
  public makeCall({ params, meetingId }: { params: Dictionary<string>, meetingId: number }) {
    //-- Sent Event -- ed-call listen this event and start a call with the sip server
    this.$edEventBus.$emit(CALLS_EVENTS.CLICK_CALL_START, params, meetingId);
  }

  public showGenericModal(body?, typeError?) {
    var bodyStr = body ? body : this.$i18n.t('meetings.homeMeetings.errorLoading');
    var typeErr = body ? typeError : KEYS.EVENT_TYPES.DANGER;
    if(this.$refs && (this.$refs as any).EdLoading) {
      (this.$refs as any).EdLoading.hide()
    }
    if(this.$EdModal) {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('meetings.customizeGroups.errorTitle'),
        body: bodyStr,
        type: typeErr
      });
    }
  }

  private mapPresentationTeacherConnect(message : WebSocketMessageResponse){
    if(!this.eventProcessors[message.messageType] || message.userType !== KEYS.TEACHER){
      return;
    }
    let content = message.content ? JSON.parse(message.content) : {};
    this.executeProccesor(message.messageType, content, message.topicId);
  }

  private executeProccesor(messageType : string, content : any, topicId : number) : void {
    this.eventProcessors[messageType]({...content, topicId: topicId});
  }

  private processSubscribe(content : any){
    if(!content || !content.roomId){
      return;
    }
    this.$store.commit(_MEETINGS_STORE.MUTATIONS.ADD_PRESENTATION_MODE_MEETING, content.roomId);
    this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.SUSCRIBE_TEACHER_EVENT);
  }

  private processLeave(content : any){
    if(!content.topicId){
      return;
    }
    this.$store.commit(_MEETINGS_STORE.MUTATIONS.REMOVE_PRESENTATION_MODE_MEETING, content.topicId);
    this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT);
    // this.verifyAlertStatus();
  }

  private validateActiveMeeting(message : WebSocketMessageResponse) : void {
    if(!message || message.messageType !== EVENT_TYPES.userConnect || !message.messages){
      return;
    }
    for (const key in message.messages) {
      let content = JSON.parse(message.messages[key].content);
      this.executeProccesor(EVENT_TYPES.subscribe, content, content.roomId);
    }
  }


  private userMeetingConnected() : void {
    let socketSubscription : string = `${SOCKET_EVENTS.response}${this.$store.state.AuthStore.user.userId}`;
    if(this.$EdSocket.validateExistsListener(socketSubscription)){
      return;
    }
    this.$EdSocket.on(socketSubscription, (message : WebSocketMessageResponse) => {
      if(!this.isPublisher) {
        this.validateActiveMeeting(message);
        this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.LOAD_ALL_MESSAGES, message);
        this.$edEventBus.$emit(MEETING_EVENTS.ALL_USER_MESSAGES, message);
        this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.LOAD_ALL_MESSAGES, message);
      }
      else if (message.messageType === HOMEWORK_SOCKET_MESSAGES_TYPES.taskUsersOnline) {
        this.$store.commit(HOMEWORKS_STORE.MUTATIONS.INIT_ONLINE_HOMEWORK_DATA, message);
        this.$edEventBus.$emit(EMIT_JOIN_SOCKET_EVENT);
      }
      if (message.messageType == HOMEWORK_SOCKET_MESSAGES_TYPES.usersOnTask) {
        this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_ONLINE_HOMEWORK_USERS_COLLABORATING, message);
      }
      if (CLASS_MESSAGES_TYPE.includes(message.messageType)) {
          this.$edEventBus.$emit(LOAD_CLASS_MESSAGES, message);
      }
      if (ROOM_CLASS_MESSAGES_TYPE.includes(message.messageType)) {
        this.$edEventBus.$emit(LOAD_ROOM_CLASS_MESSAGES, message);
      }
      if (TEMPLATE_MESSAGES_TYPE.includes(message.messageType)) {
        this.$edEventBus.$emit(LOAD_TEMPLATE_MESSAGES, message);
      }
      if (GRADE_LEVEL_MESSAGES_TYPE.includes(message.messageType)) {
        this.$edEventBus.$emit(LOAD_GRADE_LEVEL_MESSAGES, message);
      }
    });
    this.socketConnection = socketSubscription;
  }

  private validateParamsToInit() : void {
    if(this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId){
      this.userMeetingConnected();
    }
  }

  private validateStoreValues(){
    this.$store.subscribe((mutation) => {
      if(mutation.type === _APP_STORE.MUTATIONS.SET_PRESENTATION_SOCKET_CONNECTED || mutation.type === AUTH_STORE.MUTATIONS.SET_USER_INFO) {
        this.validateParamsToInit();
      }
    });
  }

  private userJoinedOrLeftHomework(message : WebSocketMessageResponse) : void {
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_ONLINE_HOMEWORK_DATA, message);
  }

  mounted() {
    if(this.isPublisher) {
      if (!this.$edEventBus['_events'][HOMEWORKS_EVENTS.USER_JOINED_OR_LEFT_HOMEWORK]) {
        // Make sure we only configure one event listener for this event
        this.$edEventBus.$on(HOMEWORKS_EVENTS.USER_JOINED_OR_LEFT_HOMEWORK, this.userJoinedOrLeftHomework);
      }
      } else {
        this.$edEventBus.$off(PRESENTATION_MODE_EVENTS.RESPONSE_EVENT, this.mapPresentationTeacherConnect);
        this.$edEventBus.$on(PRESENTATION_MODE_EVENTS.RESPONSE_EVENT, this.mapPresentationTeacherConnect);

      }

    if(this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId){
      this.userMeetingConnected();
    } else {
      this.validateStoreValues();
    }
    this.$edEventBus.$on(MY_CONTENT_EVENTS.RELOAD_MENU, this.reloadMenu);
  }

  beforeDestroy() {
    this.$edEventBus.$off(MY_CONTENT_EVENTS.RELOAD_MENU, this.reloadMenu);
  }

}
